module.exports = __webpack_public_path__ + "static/caja_de_torre-f030e9526e21d9b49cf92c049e67fd0f.png";